module.exports = __webpack_public_path__ + "img/sq5.25cb1357.png";